import { render, staticRenderFns } from "./analyses.html?vue&type=template&id=bc864d3a&scoped=true&external"
import script from "./analyses.js?vue&type=script&lang=js&external"
export * from "./analyses.js?vue&type=script&lang=js&external"
import style0 from "./analyses.scss?vue&type=style&index=0&id=bc864d3a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc864d3a",
  null
  
)

export default component.exports